import { useEffect, useState } from "react"
import { axios_cms } from "../../helpers"

const useNews = () => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [links, setLinks] = useState([])

    useEffect(() => {
        const delayDebouncer = setTimeout(() => {
            fetchDocument('/posts/articles?page=1')
        }, 500)
        return () => clearTimeout(delayDebouncer)
    }, [keyword])

    const fetchDocument = async (url) => {
        setIsLoading(true)
        try {

            const response = await axios_cms.get(`${url}&tags=ppg`)
            if (response.status === 200) {
                setData(response.data.data)
                // console.log("response.data.meta.links");
                // console.log(response.data.meta.links);

                setLinks(response.data.meta.links)
            }
        } catch (error) {
            console.log(error);

        } finally {
            setIsLoading(false)
        }

    }

    const handleChangePage = (url) => {
        const urlObj = new URL(url);
        const pathAndQuery = (urlObj.pathname + urlObj.search).replace("/api", "");
        fetchDocument(pathAndQuery)
    }

    return {
        data,
        links,
        isLoading,
        handleChangePage,
    }
}
export default useNews